/**
 * Amazon Connect Streams Client
 * 
 * This file provides a typed, centralized access point to the Amazon Connect Streams SDK.
 * All other files should import from here rather than accessing window.connect directly.
 */
import 'amazon-connect-streams';

// Export a typed reference to the connect object
export const connectClient = window.connect;

// Commonly used types and enums
export const AgentStateType = connectClient.AgentStateType;
export const ContactStateType = connectClient.ContactStateType;
export const ConnectionStateType = connectClient.ConnectionStateType;
export const ContactType = connectClient.ContactType;
export const EndpointType = connectClient.EndpointType;
export const EventType = connectClient.EventType;

// Create an Endpoint by phone number
export const createPhoneEndpoint = (phoneNumber: string) => {
    return connectClient.Endpoint.byPhoneNumber(phoneNumber);
};

// Check if the SDK is loaded
export const isConnectLoaded = (): boolean => {
    return typeof window.connect !== 'undefined';
};

/** Tear down Streams subscriptions and remove the CCP iframe from its container. */
export function terminateCcp(container?: HTMLElement | null): void {
    try {
        const terminate = (connectClient.core as { terminate?: () => void }).terminate;
        if (typeof terminate === 'function') {
            terminate.call(connectClient.core);
        }
    } catch (e) {
        console.warn('[connectClient] terminate failed', e);
    }

    const host = container ?? document.getElementById('aws-connect-ccp-container');
    if (!host) return;

    const iframe = host.querySelector('iframe');
    if (iframe) {
        iframe.remove();
    }
}

/** Open the Connect login flow after logout without a full page reload. */
export function reauthenticateCcp(): void {
    const reauth = (connectClient.core as { reauthenticateAfterLogout?: () => void })
        .reauthenticateAfterLogout;
    if (typeof reauth !== 'function') {
        throw new Error('connect.core.reauthenticateAfterLogout is not available');
    }
    reauth.call(connectClient.core);
}
